import React, { useState } from 'react';

const Support = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle support ticket submission
    setSubmitted(true);
  };

  return (
    <div className="bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Customer Support</h1>
          <p className="text-xl text-gray-600">We're here to help you 24/7</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="text-4xl mb-4">📞</div>
            <h3 className="text-xl font-bold mb-2">Phone Support</h3>
            <p className="text-gray-600 mb-2">Toll Free Number</p>
            <p className="text-2xl font-bold text-red-600">1800-123-4567</p>
            <p className="text-sm text-gray-500 mt-2">Mon-Sat: 9 AM - 8 PM</p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="text-4xl mb-4">✉️</div>
            <h3 className="text-xl font-bold mb-2">Email Support</h3>
            <p className="text-gray-600 mb-2">Send us an email</p>
            <p className="text-lg font-semibold">support@janvahan.com</p>
            <p className="text-sm text-gray-500 mt-2">24x7 Response within 24 hours</p>
          </div>

          <div className="bg-white rounded-lg shadow-lg p-6 text-center">
            <div className="text-4xl mb-4">💬</div>
            <h3 className="text-xl font-bold mb-2">Live Chat</h3>
            <p className="text-gray-600 mb-2">Chat with our experts</p>
            <button className="mt-2 bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700">
              Start Chat
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-bold mb-6">Submit a Support Ticket</h2>
          {submitted ? (
            <div className="text-center py-8">
              <div className="text-6xl mb-4">✅</div>
              <h3 className="text-2xl font-bold mb-2">Ticket Submitted!</h3>
              <p className="text-gray-600">We'll get back to you within 24 hours.</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Your Name *"
                  required
                  className="w-full px-4 py-2 border rounded-lg"
                />
                <input
                  type="email"
                  placeholder="Email Address *"
                  required
                  className="w-full px-4 py-2 border rounded-lg"
                />
              </div>
              <input
                type="text"
                placeholder="Subject *"
                required
                className="w-full px-4 py-2 border rounded-lg"
              />
              <textarea
                placeholder="Describe your issue *"
                rows="6"
                required
                className="w-full px-4 py-2 border rounded-lg"
              ></textarea>
              <button
                type="submit"
                className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition"
              >
                Submit Ticket
              </button>
            </form>
          )}
        </div>

        {/* FAQ Section */}
        <div className="mt-12">
          <h2 className="text-2xl font-bold mb-6 text-center">Frequently Asked Questions</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-6">
              <h3 className="font-bold mb-2">How long does delivery take?</h3>
              <p className="text-gray-600">Delivery typically takes 7-10 business days after booking confirmation.</p>
            </div>
            <div className="bg-white rounded-lg p-6">
              <h3 className="font-bold mb-2">What is the warranty period?</h3>
              <p className="text-gray-600">We offer 3 years or 50,000 km warranty on all electric bikes.</p>
            </div>
            <div className="bg-white rounded-lg p-6">
              <h3 className="font-bold mb-2">How to schedule a test ride?</h3>
              <p className="text-gray-600">You can schedule a test ride through our website or visit any dealership.</p>
            </div>
            <div className="bg-white rounded-lg p-6">
              <h3 className="font-bold mb-2">What financing options are available?</h3>
              <p className="text-gray-600">We offer easy EMI options with leading banks and NBFCs.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;